<template>
  <div class="container-fluid">
    <v-row class="justify-center">
      <v-col cols="12" md="7" sm="12" xs="12">
        <div
          class="wow fadeInLeftBig"
          data-wow-duration="0.5s"
          data-wow-delay="0.2s"
          id="canvas-container"
        >
          <div v-show="!loading" class="button-oncanvas"></div>
          <div
            @click="PauseStream()"
            v-show="isPauseStream"
            class="button-oncanvas-pause-stream"
          ></div>
          <!-- <div v-show="!loading && checkMobile" class="zone-button-oncanvas">
            <v-btn
              class="ma-1"
              :outlined="hands ? false : true"
              color="teal"
              @click="hands = !hands"
            >
              Hands
            </v-btn>
            <v-btn
              class="ma-1"
              :outlined="faceMesh ? false : true"
              color="teal"
              @click="faceMesh = !faceMesh"
            >
              FaceMesh
            </v-btn>
            <v-btn
              class="ma-1"
              :outlined="isBackgroundImage ? false : true"
              color="teal"
              @click="isBackgroundImage = !isBackgroundImage"
            >
              Change Background
            </v-btn>
          </div> -->
          <canvas
            ref="canvas123456"
            class="wow fadeInLeftBig"
            data-wow-duration="0.5s"
            data-wow-delay="0.2s"
            v-show="!loading"
            id="output_canvas-selfie"
            :width="widthVd.toString() + 'px'"
            :height="heightVd.toString() + 'px'"
            @click="PauseStream()"
          >
          </canvas>
        </div>
        <div v-show="!loading" class="table-wrapper-supported-plaforms">
          <table>
            <thead>
              <tr>
                <th>Browser</th>
                <th>Platform</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Chrome</td>
                <td>Android / Windows / Mac</td>
                <td>Pixel 4 and older unsupported. Fuschia</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>unsupported.</td>
              </tr>
              <tr>
                <td>Chrome</td>
                <td>iOS</td>
                <td>Camera unavailable in Chrome on iOS.</td>
              </tr>
              <tr>
                <td>Safari</td>
                <td>iPad/iPhone/Mac</td>
                <td>iOS and Safari on iPad / iPhone /</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>MacBook</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
      <v-col v-show="!loading" cols="12" md="5" sm="12" xs="12">
        <v-card
          class="wow fadeInLeftBig"
          data-wow-duration="1s"
          data-wow-delay="0.5s"
        >
          <div id="video-container">
            <video hidden id="input_video"></video>
          </div>
          <v-btn
            hidden
            x-small
            absolute
            depressed
            style="
              top: 30px;
              left: 30px;
              background-color: red;
              pointer-events: none;
            "
            color="red"
            fab
          ></v-btn>

          <v-list-item three-line>
            <v-list-item-content>
              <h4>Livestream</h4>

              <span>
                Segmentation segments the prominent humans in the scene. It can
                run in real-time on both smartphones and laptops.</span
              >

              <span class="text--primary">
                The intended use cases include selfie effects and video
                conferencing, where the person is close (under 2m) to the
                camera.</span
              >

              <!-- <v-list-item-subtitle
                >Selfie Segmentation segments the prominent humans in the scene.
                It can run in real-time on both smartphones and laptops. The
                intended use cases include selfie effects and video
                conferencing, where the person is close (UNDER 2m) to the
                camera.</v-list-item-subtitle
              > -->
              <v-card-text>
                <v-switch
                  inset
                  v-model="isBackgroundImage"
                  :label="`Enable Background Detection`"
                ></v-switch>
                <v-card-actions v-show="isBackgroundImage">
                  <v-row v-show="!loading" class="justify-center mb-2">
                    <v-col
                      v-for="(background, index) in listBackground"
                      :key="index"
                      cols="6"
                    >
                      <v-img
                        height="100"
                        class="wow fadeInLeftBig choose-background-selfie"
                        data-wow-duration="0.5s"
                        data-wow-delay="0.2s"
                        :class="[
                          background.url === url_img ? 'active-background' : '',
                        ]"
                        @click="
                          setActiveBackground(background.url, background.id)
                        "
                        :src="background.url"
                        aspect-ratio="1.7"
                      ></v-img>
                    </v-col>
                  </v-row>
                </v-card-actions>
                <v-switch
                  v-model="hands"
                  inset
                  :label="`Enable Hand Detection`"
                ></v-switch>

                <v-switch
                  v-model="faceMesh"
                  inset
                  :label="`Enable Face Mesh Detection`"
                ></v-switch>
                <!-- <v-card-actions v-show="faceMesh">
                  <v-row v-show="!loading" class="justify-center mb-2">
                    <v-col cols="6">
                      <v-img
                        height="100"
                        class="wow fadeInLeftBig choose-mask-face-mesh"
                        data-wow-duration="0.5s"
                        data-wow-delay="0.2s"
                        src="https://t3.ftcdn.net/jpg/02/15/15/46/360_F_215154625_hJg9QkfWH9Cu6LCTUc8TiuV6jQSI0C5X.jpg"
                        @click="setMask(null)"
                        aspect-ratio="1.7"
                      ></v-img>
                    </v-col>
                    <v-col
                      v-for="(mask, index) in listMask"
                      :key="index"
                      cols="6"
                    >
                      <v-img
                        height="100"
                        class="wow fadeInLeftBig choose-mask-face-mesh"
                        data-wow-duration="0.5s"
                        data-wow-delay="0.2s"
                        :src="mask.url"
                        @click="setMask(mask.url)"
                        aspect-ratio="1.7"
                      ></v-img>
                    </v-col>
                  </v-row>
                </v-card-actions> -->
                <!-- <v-switch
                  v-model="objectron"
                  inset
                  :label="`Enable Objectron Detection`"
                ></v-switch> -->
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-show="isLoadingVideo" class="justify-center">
      <v-progress-circular
        :rotate="360"
        :size="100"
        :width="15"
        :value="valueProgress"
        color="#29b37f"
      >
        {{ valueProgress }}
      </v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { Camera } from "@mediapipe/camera_utils";
import { FaceMesh, FACEMESH_TESSELATION } from "@mediapipe/face_mesh";
import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";
import { isMobile } from "mobile-device-detect";
import { Hands, HAND_CONNECTIONS } from "@mediapipe/hands";
import { BOX_CONNECTIONS, Objectron } from "@mediapipe/objectron";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import IronMark from "../../../../assets/pngironman.png";
import IronMan3 from "../../../../assets/ironman3.png";
import IronMan2 from "../../../../assets/ironman2.png";
export default {
  name: "DemoveRemBkgr",
  created() {
    this.url_img =
      localStorage.getItem("BGR_IMG") ||
      "https://images4.alphacoders.com/936/936378.jpg";
  },

  components: {},
  data() {
    return {
      checkMobile: isMobile,
      valueProgress: 10,
      isLoadingVideo: true,
      indexTab: "",
      url_img: "",
      reload: 0,
      widthVd: 0,
      heightVd: 0,
      sizeHeightMask: 250,
      sizeWidthMask: 250,
      timeNow: new Date().getTime().toString(),
      loading: true,
      hands: false,
      isBackgroundImage: false,
      faceMesh: false,
      objectron: false,
      isPauseStream: false,
      listMask: [
        {
          id: 1,
          url: IronMark,
        },
        {
          id: 2,
          url: IronMan2,
        },
        {
          id: 3,
          url: IronMan3,
        },
      ],
      maskChoosen: null,
      listBackground: [
        {
          id: 1,
          url: "https://mamnonanhduongvt.edu.vn/wp-content/uploads/2022/07/link-tai-hinh-nen-zoom-dep-cute-mien-phi-2.jpg",
        },
        {
          id: 2,
          url: "https://toigingiuvedep.vn/wp-content/uploads/2022/01/hinh-nen-zoom-dep.jpg",
        },
        {
          id: 3,
          url: "https://thietbihop.com/wp-content/uploads/2021/07/virtual-background-003.jpg",
        },
      ],
    };
  },
  computed: {},
  methods: {
    setBgr() {
      document.getElementById(
        "output_canvas-selfie"
      ).style.backgroundImage = `url('${this.url_img}')`;

      localStorage.setItem("BGR_IMG", this.url_img);
    },
    setActiveBackground(backgroundUrl, index) {
      window.scrollTo({
        top: document.getElementById("output_canvas-selfie").offsetTop,
        left: 0,
        behavior: "smooth",
      });
      document.getElementById(
        "output_canvas-selfie"
      ).style.backgroundImage = `url('${backgroundUrl}')`;
      this.url_img = backgroundUrl;
      localStorage.setItem("BGR_IMG", backgroundUrl);
      localStorage.setItem("ActiveImage", index);
    },
    updateSizeVideoMobile() {
      const ratio = 3 / 4;
      const elVideo = document.getElementById("canvas-container");
      this.widthVd = elVideo.clientWidth;
      this.heightVd = this.widthVd / ratio;
    },
    updateSizeVideo() {
      const ratio = 16 / 9;
      const elVideo = document.getElementById("canvas-container");
      this.widthVd = elVideo.clientWidth;
      this.heightVd = this.widthVd / ratio;
    },

    PauseStream() {
      this.isPauseStream = !this.isPauseStream;
      if (this.isPauseStream) {
        document.getElementById("input_video").pause();
      } else {
        document.getElementById("input_video").play();
      }
    },
    setMask(mask) {
      window.scrollTo({
        top: document.getElementById("output_canvas-selfie").offsetTop,
        left: 0,
        behavior: "smooth",
      });
      if (mask === null) {
        this.maskChoosen = null;
      } else {
        this.maskChoosen = mask;
      }
    },
    onResultsHands(results) {
      const canvasElement = document.getElementById("output_canvas-selfie");
      const canvasCtx = canvasElement.getContext("2d");
      if (results.multiHandLandmarks) {
        for (const landmarks of results.multiHandLandmarks) {
          drawConnectors(canvasCtx, landmarks, HAND_CONNECTIONS, {
            color: "#00FF00",
            lineWidth: 5,
          });
          drawLandmarks(canvasCtx, landmarks, {
            color: "#FF0000",
            lineWidth: 2,
          });
        }
      }
    },
    onResultsRemoveBackGround(results) {
      const canvasElement = document.getElementById("output_canvas-selfie");
      const canvasCtx = canvasElement.getContext("2d");

      if (this.isBackgroundImage) {
        canvasCtx.save();
        canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);
        // Only overwrite missing pixels.
        // Only overwrite existing pixels.
        canvasCtx.drawImage(
          results.segmentationMask,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
        canvasCtx.globalCompositeOperation = "source-out";
        canvasCtx.fillRect(0, 0, canvasElement.width, canvasElement.height);
        canvasCtx.drawImage(
          results.image,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );

        canvasCtx.restore();
      } else {
        // canvasCtx.save();
        // canvasCtx.clearRect(0, 0, canvasElement.width, canvasElement.height);

        canvasCtx.drawImage(
          results.image,
          0,
          0,
          canvasElement.width,
          canvasElement.height
        );
        canvasCtx.restore();
      }
    },
    onResultsObjectron(results) {
      const canvasElement = document.getElementById("output_canvas-selfie");
      const canvasCtx = canvasElement.getContext("2d");
      canvasCtx.save();
      if (results.objectDetections) {
        for (const detectedObject of results.objectDetections) {
          // Reformat keypoint information as landmarks, for easy drawing.
          const landmarks = detectedObject.keypoints.map((x) => x.point2d);
          // Draw bounding box.
          drawConnectors(canvasCtx, landmarks, BOX_CONNECTIONS, {
            color: "#FF0000",
          });
          // Draw centroid.
          drawLandmarks(canvasCtx, [landmarks[0]], {
            color: "#FFFFFF",
          });
        }
      }
      canvasCtx.restore();
    },
    onResultsFaceMesh(results) {
      const canvasElement = document.getElementById("output_canvas-selfie");
      const canvasCtx = canvasElement.getContext("2d");
      const img = new Image();
      img.src = this.maskChoosen;
      img.objectFit = "contain";
      canvasCtx.save();
      if (results.multiFaceLandmarks) {
        for (const landmarks of results.multiFaceLandmarks) {
          if (this.maskChoosen) {
            canvasCtx.drawImage(
              img,
              parseFloat(landmarks[0].x).toFixed(2) * canvasElement.width - 150,
              parseFloat(landmarks[0].y).toFixed(2) * canvasElement.height -
                150,
              this.sizeWidthMask,
              this.sizeHeightMask
            );

            canvasCtx.fillRect(0, 0, 0, 0);
          } else {
            drawConnectors(canvasCtx, landmarks, FACEMESH_TESSELATION, {
              color: "#C0C0C070",
              lineWidth: 1,
            });
          }
        }
      }
      canvasCtx.translate(canvasElement.width, 0);
      canvasCtx.restore();
    },
    async RunMediaPipe() {
      const videoElement = document.getElementById("input_video");
      const canvasElement = document.getElementById("output_canvas-selfie");

      const selfieSegmentation = new SelfieSegmentation({
        locateFile: (file) => {
          return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
        },
      });
      selfieSegmentation.setOptions({
        modelSelection: 0,
      });
      selfieSegmentation.onResults(this.onResultsRemoveBackGround);

      const hands = new Hands({
        locateFile: (file) => {
          return `https://cdn.jsdelivr.net/npm/@mediapipe/hands/${file}`;
        },
      });
      hands.setOptions({
        maxNumHands: 5,
        modelComplexity: 1,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });

      hands.onResults(this.onResultsHands);
      const faceMesh = new FaceMesh({
        locateFile: (file) => {
          return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
        },
      });
      faceMesh.setOptions({
        staticImageMode: true,
        maxNumFaces: 1,
        refineLandmarks: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });
      faceMesh.onResults(this.onResultsFaceMesh);

      const objectron = new Objectron({
        locateFile: (file) => {
          return `https://cdn.jsdelivr.net/npm/@mediapipe/objectron/${file}`;
        },
      });
      objectron.setOptions({
        modelName: "Chair",
        maxNumObjects: 3,
      });
      objectron.onResults(this.onResultsObjectron);
      const camera = new Camera(videoElement, {
        onFrame: async () => {
          await selfieSegmentation.send({ image: videoElement });
          this.isLoadingVideo = false;
          if (this.hands) {
            await hands.send({ image: videoElement });
          }
          if (this.faceMesh) {
            await faceMesh.send({ image: videoElement });
          }
          if (this.objectron) {
            await objectron.send({ image: videoElement });
          }
        },
        width: 1920,
        height: 1080,
        facingMode: "user",
      });
      await camera.start();
      canvasElement.style.backgroundImage = `url('${this.url_img}')`;
    },
  },
  async mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    window.onresize = () => {
      if (isMobile) {
        this.updateSizeVideoMobile();
      } else {
        this.updateSizeVideo();
      }
    };
    setTimeout(() => {
      this.valueProgress = 100;
    }, 100);

    setTimeout(async () => {
      this.RunMediaPipe();
    }, 2000);
    setTimeout(() => {
      if (isMobile) {
        this.updateSizeVideoMobile();
        this.loading = false;
      } else {
        this.updateSizeVideo();
        this.loading = false;
      }
    }, 4000);
  },
};
</script>

<style lang="scss" scoped>
#output_canvas-selfie {
  /*background-image: url("https://wallpapercave.com/wp/wp4676582.jpg");*/
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  /*margin-bottom: 10px;*/
}
.choose-background-selfie {
  border-radius: 5px;
  &:hover {
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
}
.choose-mask-face-mesh {
  &:hover {
    cursor: pointer;
  }
}
.active-background {
  border: 4px solid #29b37f;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}
.table-wrapper-supported-plaforms {
  margin-top: 5px;
  border: 1px solid #f2f2f2;
  border-collapse: collapse;
  tr:nth-child(even) {
    background-color: #f2f2f2;
  }
  table {
    width: 100%;
  }
}
#canvas-container {
  position: relative;
  &:hover {
    .button-oncanvas-pause-stream {
      display: inline;
    }
  }
  .button-oncanvas {
    position: absolute;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    top: 20px;
    left: 20px;
    background-color: red;
    animation-name: example;
    animation-duration: 2s;
    animation-iteration-count: infinite;
  }
  .button-oncanvas-pause-stream {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 20px solid transparent;
    border-bottom: 30px solid transparent;
    border-left: 40px solid rgb(255, 255, 255);
    top: 50%;
    left: 50%;
    display: none;
  }
  .zone-button-oncanvas {
    position: absolute;
    top: 10px;
    left: 50px;
  }
  @keyframes example {
    0% {
      background-color: red;
    }
    5% {
      background-color: rgb(214, 1, 1);
    }
    10% {
      background-color: rgb(205, 2, 2);
    }
    15% {
      background-color: rgb(177, 1, 1);
    }
    20% {
      background-color: rgb(158, 2, 2);
    }
    25% {
      background-color: rgb(156, 2, 2);
    }
    30% {
      background-color: rgb(109, 1, 1);
    }
    35% {
      background-color: rgb(126, 0, 0);
    }
    40% {
      background-color: rgb(157, 0, 0);
    }
    45% {
      background-color: rgb(179, 2, 2);
    }
    50% {
      background-color: rgb(183, 3, 3);
    }
    55% {
      background-color: rgb(185, 2, 2);
    }
    60% {
      background-color: rgb(189, 0, 0);
    }
    65% {
      background-color: rgb(190, 1, 1);
    }
    70% {
      background-color: rgb(191, 0, 0);
    }
    75% {
      background-color: rgb(195, 0, 0);
    }
    80% {
      background-color: rgb(200, 0, 0);
    }
    85% {
      background-color: rgb(225, 0, 0);
    }
    90% {
      background-color: rgb(235, 0, 0);
    }
    100% {
      background-color: rgb(255, 0, 0);
    }
  }
}
</style>
